import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  getCurrentRouterPathname,
  highlightedAfterEditAtomFamily,
  isKanbanViewPathname,
  Log,
  RydeUiUnit,
} from "@ryde/shared";

const HIGHLIGHT_TIMEOUT = 8_000;
const HIGHLIGHT_TIMEOUT_KANBAN = 15_000;

/**
 * Deliberately subscription-free: this hook is instantiated by nine callers (including the
 * page provider chain), so it must not hold router or read subscriptions. The kanban timeout is
 * therefore resolved from the current route pathname at the moment a highlight is set, rather
 * than from a `useLocation()` subscription held for each caller's whole lifetime.
 */
export const useHighlightEdited = (entity: RydeUiUnit) => {
  const setRowsIds = useSetRecoilState(highlightedAfterEditAtomFamily(entity));

  const resetHighlightedRows = useEvent((): void => {
    Log.debug("Clear highlighted rows");
    setRowsIds([]);
  });

  const setHighlightedRows = useEvent((ids: number[]): void => {
    Log.debug("Set highlighted rows", ids);

    const timeOutComputed = isKanbanViewPathname(getCurrentRouterPathname())
      ? HIGHLIGHT_TIMEOUT_KANBAN
      : HIGHLIGHT_TIMEOUT;

    setRowsIds(ids);
    setTimeout(() => resetHighlightedRows(), timeOutComputed);
  });

  return { setHighlightedRows };
};
